module.exports = __webpack_public_path__ + "static/media/ALTHAR_Serverless-Computing.e7043e9b.png";